<template>
  <section id="courseSelect" class="courseSelect">
    <div class="">
      <div class="card-alt-body">
        <div class="page-header">
          <div class="row justify-content-end">
            <div class="col-md-6">
              <h2 class="page-title">{{$t('candidateApplications.title')}}</h2>
            </div>
            <div class="col-md-6 blue-color">
            <small><strong>( {{$t('candidateApplications.instruction1')}} )</strong></small> 
            </div>
          </div>
        </div>
      </div>
      <div class="row">
          <div class="col-12">
            <div class=" card-sec">
                <!-- <div class="mb-3">
                 <small><b>{{$t('candidateApplications.instruction1')}}</b></small>
                </div> -->
                <div class="input-group col-md-12 mb-3">
                  <span class="input-group-addon" id="search"><i class="mdi mdi-magnify"></i></span>
                  <input type="text" class="form-control" :placeholder="$t('candidateApplications.plceHoSearchBox')" id="searchBox" v-model="searchBox">
                </div>
                <div class="row">
                <div class="col-md-6" v-for="item in filterCourseUnivList" :key="item.courseID + item.uniID">
                  <div class="card-course">
                    <!-- <i class="mdi mdi-school course-icon"></i> -->
                    <img :src="getLogoUrl(item.abbr)"  class="course-icon" :alt="item.abbr" width="70px">
                    <div class="card-data">
                    <div class="ctitle">{{item.courseName}}</div>
                    <div class="utitle">{{item.uniName}}</div>
                    <hr/>
                    <button class="btn btn-success-alt" v-on:click="showConfirmation = true;courseObj = item">{{$t('button.apply')}}</button>
                    <a class="btn btn-info-alt" v-bind:href="item.courseInfoUrl" target="_blank">{{$t('button.view')}}</a>
                    </div>
                  </div>
                </div>
                </div>
                <div v-if="filterCourseUnivList.length < 1" class="red">
                  {{$t('candidateApplications.erorNotMatchFound')}}
                </div>
              </div>
          </div>
      </div>
      <modal class="sm" v-if="showConfirmation" @close="showConfirmation = false">   
          <h3 slot="header">{{$t('candidateApplications.confirmText')}}
          </h3>
            <hr>
          <div slot="body">
            {{courseObj.courseName}} {{$t('candidateApplications.atlbl')}} {{courseObj.uniName}}
           </div>
           <div slot="footer">
            <button type="button" class="btn btn btn-success-alt mr-3" @click="apply(courseObj)"> {{$t('button.confirm')}}</button>             
            <button type="button" class="btn btn btn-danger-alt mr-3" @click="showConfirmation = false"> {{$t('button.cancel')}}</button>             
           </div>
    </modal>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import modal from '@/components/common/modal.vue'
export default {
  name: 'candidateApplication',
  components: {modal},
  data () {
    return {
      courseUnivList: [],
      searchBox: '',
      courseObj: {},
      showConfirmation: false
    }
  },
  computed: {
    filterCourseUnivList: function () {
      var self = this
      return self.courseUnivList.filter(function (user) {
        var searchRegex = new RegExp(self.searchBox, 'i')
        return searchRegex.test(user.uniName) ||
      searchRegex.test(user.courseName)
      })
    }
  },
  methods: {
    getLogoUrl (abbr) {
      return 'static/assets/images/' + abbr + '.png'
    },
    getAllData: function () {
        // Get course and university mapping List.
      axios
        .get('r/candidateApplication/getCourseUnivList')
        .then(response => {
          this.courseUnivList = response.data
        })
        .catch(e => {
          console.log(e)
        })
    },
    // This method get exist status of application in candidate_application collection(mongoDB).
    apply: function (applicationObj) {
      var userName = this.$store.state.candidateProfile.profileUser
      var courseID = applicationObj.courseID
      var universityID = applicationObj.uniID
      axios
        .get('r/candidateApplication/existStatusOfApplication/' + userName + '/' + courseID + '/' + universityID)
        .then(response => {
          if (response.data === true) {
            this.$toasted.info(this.$t('candidateApplications.toastrAppAlreadyExist'))
            this.showConfirmation = false
            return false
          } else {
            this.$router.push({ path: `/workPlace/${courseID}/${universityID}` })
            // this.$router.push({name: 'workPlace', params: {userName: userName, courseID: courseID, universityID: universityID}})
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    fetchUserDetails: function () {
      axios.get('/r/entry/getUserApplicationStatus/' + this.$store.state.candidateProfile.profileUser).then(response => {
        if (response.data !== null && response.data.appStatus) {
          this.$store.commit('STORE_CONFIRM_STATUS', true)
          window.MKCLAPI.switchAppWithSingleSignOn(this.MFS_CLIENT_ID)
        } else {
          this.getAllData()
        }
      }).catch(function (e) {
        console.error(e)
      })
    }
  },
  created: function () {
    this.fetchUserDetails()
  }
}
</script>

<style lang="scss">
.courseSelect{  
   .card-alt {
    // margin:0px;
    padding: 40px;
    min-height: 600px;
    margin-bottom:80px;
    // box-shadow: none;
  }
  .card-alt-body {
    padding-top: 0px;
  }
  .card-alt-header {
    padding-left: 15px;
    padding-top: 40px;
    padding-bottom: 10px;
  }
  .input-group{
    
    border: 1px solid #f2f2f2;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
    padding: 0;
   border-radius:5px;
    .input-group-addon{
       background: #fff;padding: 10px;line-height: 25px;   
      .mdi{font-size:20px; display: inline-block; margin-top:-9px; color:#6C757D;}
    }
    .form-control{
      background-color:transparent;
          
    font-family: inherit;
    font-weight: 500;
    background: #fff;
    color: inherit;
    box-shadow: none;
    border:none;
    }
  }
      .card-sec{
          
        margin-top:30px;
        margin-bottom:50px;
            .card-course{
              margin-bottom:40px;
                padding-top:30px;
                padding:20px;
                transition: all 0.3s cubic-bezier(.25,.8,.25,1);
                box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);  
                border-radius: 5px;
                border:1px solid #fff;
                background: #fff; 
                // transition: 300ms ease; transition: 300ms ease; position: relative;
                &:hover {
                    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
                    // .btn{background: lighten(#4885ed,22%); color:#4885ed; font-weight:600; letter-spacing: 0.2px;}
                }
                hr{border-color:transparent;}
                .ctitle{font-size:18px; font-weight: 400;}
                .utitle{font-size:14px;}
                .btn{
                    border:none; 
                    padding:8px 28px; 
                    // font-size:11px; 
                    margin-right:10px;
                    &:hover{box-shadow: none; }
                }
                .course-icon{
                      position: absolute;
                      bottom: 52px;
                      right: 34px;
                      font-size: 23px;
                      color: #f1f1f1;
                      z-index: 0
                }
                .card-data{
                  position: relative;
                  z-index: 101;
                }
            }
        }
        .help{font-size:11px; word-spacing: 1px; padding-left:12px;text-transform: uppercase; }
        .red{color:#ec4343; padding-left:15px;}
        .v-select {
            .dropdown-toggle {
            z-index: 3;
            
            border-left: 0px;
            border-right: 0px;
            border-top: 0px;
            padding-left: 0px;
            border-radius: 0px;
            font-family: 'Open Sans';
            font-weight: 600;
            border-color:#ddd;
            .clear {
                line-height: 20px;
            }
            }
            .dropdown-menu {
            z-index:3;
            // box-shadow: none;
            font-family: 'Open Sans';
            border-radius: 5px;
            font-size: 14px;
            border: none;
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
            }
            .selected-tag {
            color: #495057;
            font-size: 18px;
            font-weight: 500;
            letter-spacing: 0.25px;
            }
        }
          .custom-input {
    z-index:2;
    input::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #37474f;
      opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #37474f;
    }

    ::-ms-input-placeholder {
      /* Microsoft Edge */
      color: #37474f;
    }
    // border:0px solid #ddd;
    padding: 15px;
    margin-bottom: 0;
    label {
      font-size: 11px;
      color: #37474f;
      text-transform: uppercase;
      margin-bottom: 0;
      padding-left: 10px;
    }
   
    }
}
.blue-color {
  color:rgb(17, 104, 35);
}

</style>



// WEBPACK FOOTER //
// src/components/candidateApplication/candidateApplication.vue